/* eslint-disable radix */
import { merge } from 'ramda';
import {
  CHANGE_HELP_TAB_INDEX,
  SET_HELP_ITEM_ID,
  RESET_HELP_ITEM_ID,
  LOAD_HELP_LANGUAGES_SUCCESS,
  LOAD_HELP_LIST_REQUEST,
  LOAD_HELP_LIST_SUCCESS,
  LOAD_HELP_LIST_FAIL,
  LOAD_HELP_CATEGORIES_SUCCESS,
  LOAD_HELP_RECORD_REQUEST,
  LOAD_HELP_RECORD_SUCCESS,
  LOAD_HELP_RECORD_FAIL,
  LOAD_HELP_NEWS_SUCCESS,
  CREATE_HELP_RECORD_REQUEST,
  CREATE_HELP_RECORD_SUCCESS,
  CREATE_HELP_RECORD_FAIL,
  UPDATE_HELP_RECORD_REQUEST,
  UPDATE_HELP_RECORD_SUCCESS,
  UPDATE_HELP_RECORD_FAIL,
  DELETE_HELP_RECORD_REQUEST,
  DELETE_HELP_RECORD_SUCCESS,
  DELETE_HELP_RECORD_FAIL,
  UPDATE_HELP_LIST_ORDER,
  SET_HELP_LIST_ORDER_REQUEST,
  SET_HELP_LIST_ORDER_SUCCESS,
  SET_HELP_LIST_ORDER_FAIL
} from 'src/store/actions/helpActions';

const initialState = {
  orderFetching: false,
  listFetching: false,
  fetching: 0,
  tabIndex: 0,
  itemId: -1,
  newsList: {},
  helpItems: {},
  mainItems: {},
  categories: [],
  langList: [
    { label: 'ENG', value: 0 },
    { label: 'EST', value: 1 },
    { label: 'RUS', value: 2 }
  ],
  helpItemsDetails: {}
};

const helpReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_HELP_RECORD_REQUEST:
    case UPDATE_HELP_RECORD_REQUEST:
    case DELETE_HELP_RECORD_REQUEST:
    case LOAD_HELP_RECORD_REQUEST:
      return merge(state, { fetching: state.fetching + 1 });
    case CREATE_HELP_RECORD_FAIL:
    case UPDATE_HELP_RECORD_FAIL:
    case DELETE_HELP_RECORD_FAIL:
    case LOAD_HELP_RECORD_FAIL:
    case CREATE_HELP_RECORD_SUCCESS:
    case DELETE_HELP_RECORD_SUCCESS:
      return merge(state, { fetching: state.fetching - 1 });
    case CHANGE_HELP_TAB_INDEX:
      return merge(state, { tabIndex: action.tabIndex });
    case SET_HELP_ITEM_ID:
      return merge(state, { itemId: action.itemId });
    case RESET_HELP_ITEM_ID:
      return merge(state, { itemId: -1 });
    case LOAD_HELP_CATEGORIES_SUCCESS:
      return merge(state, { categories: [{ label: 'All', value: 0 }, ...action.categoriesList] });
    case LOAD_HELP_LANGUAGES_SUCCESS:
      return merge(state, { langList: action.langList });
    case UPDATE_HELP_RECORD_SUCCESS:
    case LOAD_HELP_RECORD_SUCCESS:
      return merge(state, {
        helpItemsDetails: merge(state.helpItemsDetails, { [action.helpRecord.id]: action.helpRecord }),
        fetching: state.fetching - 1
      });
    case UPDATE_HELP_LIST_ORDER:
      return merge(state, {
        helpItems: merge(state.helpItems, { [action.helpData.lang]: action.helpData.list }),
        mainItems: merge(state.mainItems, { [action.helpData.lang]: action.helpData.mainList })
      });
    case LOAD_HELP_LIST_REQUEST:
      return merge(state, { listFetching: action.fetching });
    case LOAD_HELP_LIST_SUCCESS:
      return merge(state, {
        helpItems: merge(state.helpItems, { [action.helpData.lang]: action.helpData.list }),
        mainItems: merge(state.mainItems, { [action.helpData.lang]: action.helpData.mainList }),
        listFetching: false
      });
    case LOAD_HELP_LIST_FAIL:
      return merge(state, { listFetching: false });
    case LOAD_HELP_NEWS_SUCCESS:
      return merge(state, {
        newsList: merge(state.newsList, { [action.helpNews.lang]: action.helpNews.list })
      });
    case SET_HELP_LIST_ORDER_REQUEST:
      return merge(state, { orderFetching: true });
    case SET_HELP_LIST_ORDER_SUCCESS:
    case SET_HELP_LIST_ORDER_FAIL:
      return merge(state, { orderFetching: false });
    default:
      return state;
  }
};

export default helpReducer;
